import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "holder" }
const _hoisted_2 = { class: "nav-wrapper dropdown" }
const _hoisted_3 = {
  class: "btn btn-nav-dropdawn dropdown-toggle d-lg-none",
  type: "button",
  id: "dropdownMenuButton",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_4 = {
  role: "tablist",
  class: "nav-list dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_5 = {
  class: "nav-item dropdown-item",
  role: "none"
}
const _hoisted_6 = {
  key: 0,
  class: "nav-link",
  role: "heading",
  "aria-level": "1"
}
const _hoisted_7 = {
  key: 1,
  class: "nav-link"
}
const _hoisted_8 = {
  class: "nav-item dropdown-item",
  role: "none"
}
const _hoisted_9 = {
  key: 0,
  class: "nav-link",
  role: "heading",
  "aria-level": "1"
}
const _hoisted_10 = {
  key: 1,
  class: "nav-link"
}
const _hoisted_11 = {
  class: "nav-item dropdown-item",
  role: "none"
}
const _hoisted_12 = {
  key: 0,
  class: "nav-link",
  role: "heading",
  "aria-level": "1"
}
const _hoisted_13 = {
  key: 1,
  class: "nav-link"
}
const _hoisted_14 = ["href", "target"]
const _hoisted_15 = ["href", "target"]

import { useFilterPageStore } from '@/stores/filterPageStore'
import { computed, onMounted, useAttrs } from 'vue'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterPage',
  setup(__props) {

const filterPageStore = useFilterPageStore()
const route = useRoute()
const router = useRouter()
const attrs = useAttrs() as {
    storiesRoute?: string;
    playlistsRoute?: string;
    toursRoute?: string;
};

const containerBg = computed(() => {
    const toursBg = '#1C613B'
    const playlistsBg = '#000000'
    const defBg = 'inherit'
    return filterPageStore.isToursPage(route.path) ? toursBg : filterPageStore.isPlaylistsPage(route.path) ? playlistsBg : defBg
})
const additionalClass = computed(() => {
    const toursClass = 'story-overview-page-2'
    const playlistsClass = 'story-overview-page-3'
    const def = ''
    return filterPageStore.isToursPage(route.path) ? toursClass : filterPageStore.isPlaylistsPage(route.path) ? playlistsClass : def
})
const toursTabName = computed(() => filterPageStore.getLocalization('FilterPage.ToursTabName') ?? '')
const storiesTabName = computed(() => filterPageStore.getLocalization('FilterPage.StoriesTabName') ?? '')
const playlistsTabName = computed(() => filterPageStore.getLocalization('FilterPage.PlaylistsTabName') ?? '')
const currentRouteName = computed(() => (filterPageStore.isToursPage(route.path) ? toursTabName : filterPageStore.isPlaylistsPage(route.path) ? playlistsTabName : storiesTabName).value)
const createNewStoryLink = computed(() => filterPageStore.createNewStory)

const { storiesRoute = '', playlistsRoute = '', toursRoute = '' } = attrs;

function refreshDataAttribute() {
    const key = document.getElementById('vue-filter-page-component')?.attributes['data-model-key']?.value;
    return key ? true : false;
}

const changePageTitle = (routeName: string) => {
    const pageTitlesMap = {
        [storiesRoute]: filterPageStore.storiesPageTitle,
        [playlistsRoute]: filterPageStore.playlistPageTitle,
        [toursRoute]: filterPageStore.toursPageTitle
    }

    document.title = pageTitlesMap[routeName] || ''
}

onMounted(async () => {
    // to fix umbraco preview (preview doesn't know about vue routing and loads just root)
    const baseRoutes = [storiesRoute, playlistsRoute, toursRoute]
    await router.isReady()

    const isBaseRoute = baseRoutes.some(substring => route.path.includes(substring))

    if (!isBaseRoute) {
        router.replace(storiesRoute)
    }

    await filterPageStore.fetchFilterPage() //TODO: mb its better to separate requests for each tab

    const fromTour = sessionStorage.getItem('fromTourPage');

    if(fromTour)
    {
        document.getElementById("tours-nav-link")?.focus();
        sessionStorage.removeItem('fromTourPage');
    }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["story-overview-page", [_unref(additionalClass)]]),
    style: _normalizeStyle({ backgroundColor: _unref(containerBg) })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", _hoisted_3, _toDisplayString(_unref(currentRouteName)), 1),
        _createElementVNode("ul", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: _unref(storiesRoute),
              class: _normalizeClass(["nav-link", refreshDataAttribute() ? 'router-link-active router-link-exact-active' : '']),
              role: "tab",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changePageTitle(_unref(storiesRoute))))
            }, {
              default: _withCtx(() => [
                (_unref(filterPageStore).isStoriesPage(_unref(route).path))
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(_unref(storiesTabName)), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(storiesTabName)), 1))
              ]),
              _: 1
            }, 8, ["to", "class"])
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: _unref(playlistsRoute),
              exact: "",
              class: "nav-link",
              role: "tab",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changePageTitle(_unref(playlistsRoute))))
            }, {
              default: _withCtx(() => [
                (_unref(filterPageStore).isPlaylistsPage(_unref(route).path))
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString(_unref(playlistsTabName)), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(playlistsTabName)), 1))
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: _unref(toursRoute),
              exact: "",
              class: "nav-link",
              id: "tours-nav-link",
              role: "tab",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changePageTitle(_unref(toursRoute))))
            }, {
              default: _withCtx(() => [
                (_unref(filterPageStore).isToursPage(_unref(route).path))
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_12, _toDisplayString(_unref(toursTabName)), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(toursTabName)), 1))
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]),
        (_unref(filterPageStore).isStoriesPage(_unref(route).path) && _unref(createNewStoryLink).Url)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-story d-none d-lg-flex",
              href: _unref(createNewStoryLink).Url,
              target: _unref(createNewStoryLink).Target
            }, _toDisplayString(_unref(createNewStoryLink).Name), 9, _hoisted_14))
          : _createCommentVNode("", true)
      ]),
      (_unref(filterPageStore).isStoriesPage(_unref(route).path) && _unref(createNewStoryLink).Url)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "btn btn-story d-lg-none",
            href: _unref(createNewStoryLink).Url,
            target: _unref(createNewStoryLink).Target
          }, _toDisplayString(_unref(createNewStoryLink).Name), 9, _hoisted_15))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ])
  ], 6))
}
}

})